/* eslint-disable */

export const createRequest =  `
  mutation CreateRequest(
    $input: CreateRequestInput!
    $condition: ModelRequestConditionInput
  ) {
    createRequest(input: $input, condition: $condition) {
      id
      requestDate
      startTime
      duration
      description
      isConfirmed
      isPending
      userID
      companyID
      address
      putOff
      groupId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRequest =  `
  mutation UpdateRequest(
    $input: UpdateRequestInput!
    $condition: ModelRequestConditionInput
  ) {
    updateRequest(input: $input, condition: $condition) {
      id
      requestDate
      startTime
      duration
      description
      isConfirmed
      isPending
      userID
      companyID
      address
      putOff
      groupId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRequest =  `
  mutation DeleteRequest(
    $input: DeleteRequestInput!
    $condition: ModelRequestConditionInput
  ) {
    deleteRequest(input: $input, condition: $condition) {
      id
      requestDate
      startTime
      duration
      description
      isConfirmed
      isPending
      userID
      companyID
      address
      putOff
      groupId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createReport =  `
  mutation CreateReport(
    $input: CreateReportInput!
    $condition: ModelReportConditionInput
  ) {
    createReport(input: $input, condition: $condition) {
      id
      conversationID
      userID
      reportedUserID
      reasonGiven
      reasonWhy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateReport =  `
  mutation UpdateReport(
    $input: UpdateReportInput!
    $condition: ModelReportConditionInput
  ) {
    updateReport(input: $input, condition: $condition) {
      id
      conversationID
      userID
      reportedUserID
      reasonGiven
      reasonWhy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteReport =  `
  mutation DeleteReport(
    $input: DeleteReportInput!
    $condition: ModelReportConditionInput
  ) {
    deleteReport(input: $input, condition: $condition) {
      id
      conversationID
      userID
      reportedUserID
      reasonGiven
      reasonWhy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPaymentMethod =  `
  mutation CreatePaymentMethod(
    $input: CreatePaymentMethodInput!
    $condition: ModelPaymentMethodConditionInput
  ) {
    createPaymentMethod(input: $input, condition: $condition) {
      id
      stripeCardToken
      nameOnCard
      brand
      userID
      last4
      expMonth
      expYear
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePaymentMethod =  `
  mutation UpdatePaymentMethod(
    $input: UpdatePaymentMethodInput!
    $condition: ModelPaymentMethodConditionInput
  ) {
    updatePaymentMethod(input: $input, condition: $condition) {
      id
      stripeCardToken
      nameOnCard
      brand
      userID
      last4
      expMonth
      expYear
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePaymentMethod =  `
  mutation DeletePaymentMethod(
    $input: DeletePaymentMethodInput!
    $condition: ModelPaymentMethodConditionInput
  ) {
    deletePaymentMethod(input: $input, condition: $condition) {
      id
      stripeCardToken
      nameOnCard
      brand
      userID
      last4
      expMonth
      expYear
      isActive
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSchedule =  `
  mutation CreateSchedule(
    $input: CreateScheduleInput!
    $condition: ModelScheduleConditionInput
  ) {
    createSchedule(input: $input, condition: $condition) {
      id
      day
      allDay
      from
      to
      companyID
      userID
      address
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSchedule =  `
  mutation UpdateSchedule(
    $input: UpdateScheduleInput!
    $condition: ModelScheduleConditionInput
  ) {
    updateSchedule(input: $input, condition: $condition) {
      id
      day
      allDay
      from
      to
      companyID
      userID
      address
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSchedule =  `
  mutation DeleteSchedule(
    $input: DeleteScheduleInput!
    $condition: ModelScheduleConditionInput
  ) {
    deleteSchedule(input: $input, condition: $condition) {
      id
      day
      allDay
      from
      to
      companyID
      userID
      address
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSavedReview =  `
  mutation CreateSavedReview(
    $input: CreateSavedReviewInput!
    $condition: ModelSavedReviewConditionInput
  ) {
    createSavedReview(input: $input, condition: $condition) {
      id
      reviewID
      savedID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSavedReview =  `
  mutation UpdateSavedReview(
    $input: UpdateSavedReviewInput!
    $condition: ModelSavedReviewConditionInput
  ) {
    updateSavedReview(input: $input, condition: $condition) {
      id
      reviewID
      savedID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSavedReview =  `
  mutation DeleteSavedReview(
    $input: DeleteSavedReviewInput!
    $condition: ModelSavedReviewConditionInput
  ) {
    deleteSavedReview(input: $input, condition: $condition) {
      id
      reviewID
      savedID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createMessages =  `
  mutation CreateMessages(
    $input: CreateMessagesInput!
    $condition: ModelMessagesConditionInput
  ) {
    createMessages(input: $input, condition: $condition) {
      id
      conversationID
      senderID
      receiverID
      messageContent
      readStatus
      timeStamp
      lastSent
      receiverDeleted
      senderDeleted
      attachmentkey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateMessages =  `
  mutation UpdateMessages(
    $input: UpdateMessagesInput!
    $condition: ModelMessagesConditionInput
  ) {
    updateMessages(input: $input, condition: $condition) {
      id
      conversationID
      senderID
      receiverID
      messageContent
      readStatus
      timeStamp
      lastSent
      receiverDeleted
      senderDeleted
      attachmentkey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteMessages =  `
  mutation DeleteMessages(
    $input: DeleteMessagesInput!
    $condition: ModelMessagesConditionInput
  ) {
    deleteMessages(input: $input, condition: $condition) {
      id
      conversationID
      senderID
      receiverID
      messageContent
      readStatus
      timeStamp
      lastSent
      receiverDeleted
      senderDeleted
      attachmentkey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBankMethod =  `
  mutation CreateBankMethod(
    $input: CreateBankMethodInput!
    $condition: ModelBankMethodConditionInput
  ) {
    createBankMethod(input: $input, condition: $condition) {
      id
      stripeBankToken
      last4
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBankMethod =  `
  mutation UpdateBankMethod(
    $input: UpdateBankMethodInput!
    $condition: ModelBankMethodConditionInput
  ) {
    updateBankMethod(input: $input, condition: $condition) {
      id
      stripeBankToken
      last4
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBankMethod =  `
  mutation DeleteBankMethod(
    $input: DeleteBankMethodInput!
    $condition: ModelBankMethodConditionInput
  ) {
    deleteBankMethod(input: $input, condition: $condition) {
      id
      stripeBankToken
      last4
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createHighlight =  `
  mutation CreateHighlight(
    $input: CreateHighlightInput!
    $condition: ModelHighlightConditionInput
  ) {
    createHighlight(input: $input, condition: $condition) {
      id
      description
      attachmentkey
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateHighlight =  `
  mutation UpdateHighlight(
    $input: UpdateHighlightInput!
    $condition: ModelHighlightConditionInput
  ) {
    updateHighlight(input: $input, condition: $condition) {
      id
      description
      attachmentkey
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteHighlight =  `
  mutation DeleteHighlight(
    $input: DeleteHighlightInput!
    $condition: ModelHighlightConditionInput
  ) {
    deleteHighlight(input: $input, condition: $condition) {
      id
      description
      attachmentkey
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createContact =  `
  mutation CreateContact(
    $input: CreateContactInput!
    $condition: ModelContactConditionInput
  ) {
    createContact(input: $input, condition: $condition) {
      id
      email
      title
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateContact =  `
  mutation UpdateContact(
    $input: UpdateContactInput!
    $condition: ModelContactConditionInput
  ) {
    updateContact(input: $input, condition: $condition) {
      id
      email
      title
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteContact =  `
  mutation DeleteContact(
    $input: DeleteContactInput!
    $condition: ModelContactConditionInput
  ) {
    deleteContact(input: $input, condition: $condition) {
      id
      email
      title
      message
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSpecialty =  `
  mutation CreateSpecialty(
    $input: CreateSpecialtyInput!
    $condition: ModelSpecialtyConditionInput
  ) {
    createSpecialty(input: $input, condition: $condition) {
      id
      type
      specialties
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSpecialty =  `
  mutation UpdateSpecialty(
    $input: UpdateSpecialtyInput!
    $condition: ModelSpecialtyConditionInput
  ) {
    updateSpecialty(input: $input, condition: $condition) {
      id
      type
      specialties
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSpecialty =  `
  mutation DeleteSpecialty(
    $input: DeleteSpecialtyInput!
    $condition: ModelSpecialtyConditionInput
  ) {
    deleteSpecialty(input: $input, condition: $condition) {
      id
      type
      specialties
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createInvoices =  `
  mutation CreateInvoices(
    $input: CreateInvoicesInput!
    $condition: ModelInvoicesConditionInput
  ) {
    createInvoices(input: $input, condition: $condition) {
      id
      totalAmount
      grandAmount
      status
      frequency
      companyID
      userID
      invoiceAttachmentKey
      dueDates
      payments
      feeAmountIncluded
      numberOfPayments
      oneTimePayment
      amount
      latePayments
      resendPayments
      paymentDate
      resent
      readStatus
      dueDateLog
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateInvoices =  `
  mutation UpdateInvoices(
    $input: UpdateInvoicesInput!
    $condition: ModelInvoicesConditionInput
  ) {
    updateInvoices(input: $input, condition: $condition) {
      id
      totalAmount
      grandAmount
      status
      frequency
      companyID
      userID
      invoiceAttachmentKey
      dueDates
      payments
      feeAmountIncluded
      numberOfPayments
      oneTimePayment
      amount
      latePayments
      resendPayments
      paymentDate
      resent
      readStatus
      dueDateLog
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteInvoices =  `
  mutation DeleteInvoices(
    $input: DeleteInvoicesInput!
    $condition: ModelInvoicesConditionInput
  ) {
    deleteInvoices(input: $input, condition: $condition) {
      id
      totalAmount
      grandAmount
      status
      frequency
      companyID
      userID
      invoiceAttachmentKey
      dueDates
      payments
      feeAmountIncluded
      numberOfPayments
      oneTimePayment
      amount
      latePayments
      resendPayments
      paymentDate
      resent
      readStatus
      dueDateLog
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createReview =  `
  mutation CreateReview(
    $input: CreateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    createReview(input: $input, condition: $condition) {
      id
      description
      score
      ghost
      attachmentkey
      companyID
      userID
      SavedReviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateReview =  `
  mutation UpdateReview(
    $input: UpdateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    updateReview(input: $input, condition: $condition) {
      id
      description
      score
      ghost
      attachmentkey
      companyID
      userID
      SavedReviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteReview =  `
  mutation DeleteReview(
    $input: DeleteReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    deleteReview(input: $input, condition: $condition) {
      id
      description
      score
      ghost
      attachmentkey
      companyID
      userID
      SavedReviews {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCompany =  `
  mutation CreateCompany(
    $input: CreateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    createCompany(input: $input, condition: $condition) {
      id
      companyUser
      companyName
      companyType
      zipcode
      email
      phone
      companyWebsite
      bio
      Reviews {
        nextToken
        __typename
      }
      Highlights {
        nextToken
        __typename
      }
      profilepicturekey
      backgroundpicturekey
      Invoices {
        nextToken
        __typename
      }
      BankMethod {
        nextToken
        __typename
      }
      town
      state
      Schedules {
        nextToken
        __typename
      }
      Specialties {
        nextToken
        __typename
      }
      emailPrivate
      phonePrivate
      blocked
      lowRange
      highRange
      stripeAccountId
      lowPrivate
      highPrivate
      isDeleted
      deletedAt
      originalUsername
      instantPayout
      Requests {
        nextToken
        __typename
      }
      messageNotifications
      paymentNotifications
      requestNotifications
      pushMessageNotifications
      pushPaymentNotifications
      pushRequestNotifications
      isClaimed
      isSeeded
      licenseNumber
      licenseValidTo
      dataSource
      claimedAt
      isBlacklisted
      latitude
      longitude
      borough
      ownerSub
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCompany =  `
  mutation UpdateCompany(
    $input: UpdateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    updateCompany(input: $input, condition: $condition) {
      id
      companyUser
      companyName
      companyType
      zipcode
      email
      phone
      companyWebsite
      bio
      Reviews {
        nextToken
        __typename
      }
      Highlights {
        nextToken
        __typename
      }
      profilepicturekey
      backgroundpicturekey
      Invoices {
        nextToken
        __typename
      }
      BankMethod {
        nextToken
        __typename
      }
      town
      state
      Schedules {
        nextToken
        __typename
      }
      Specialties {
        nextToken
        __typename
      }
      emailPrivate
      phonePrivate
      blocked
      lowRange
      highRange
      stripeAccountId
      lowPrivate
      highPrivate
      isDeleted
      deletedAt
      originalUsername
      instantPayout
      Requests {
        nextToken
        __typename
      }
      messageNotifications
      paymentNotifications
      requestNotifications
      pushMessageNotifications
      pushPaymentNotifications
      pushRequestNotifications
      isClaimed
      isSeeded
      licenseNumber
      licenseValidTo
      dataSource
      claimedAt
      isBlacklisted
      latitude
      longitude
      borough
      ownerSub
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCompany =  `
  mutation DeleteCompany(
    $input: DeleteCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    deleteCompany(input: $input, condition: $condition) {
      id
      companyUser
      companyName
      companyType
      zipcode
      email
      phone
      companyWebsite
      bio
      Reviews {
        nextToken
        __typename
      }
      Highlights {
        nextToken
        __typename
      }
      profilepicturekey
      backgroundpicturekey
      Invoices {
        nextToken
        __typename
      }
      BankMethod {
        nextToken
        __typename
      }
      town
      state
      Schedules {
        nextToken
        __typename
      }
      Specialties {
        nextToken
        __typename
      }
      emailPrivate
      phonePrivate
      blocked
      lowRange
      highRange
      stripeAccountId
      lowPrivate
      highPrivate
      isDeleted
      deletedAt
      originalUsername
      instantPayout
      Requests {
        nextToken
        __typename
      }
      messageNotifications
      paymentNotifications
      requestNotifications
      pushMessageNotifications
      pushPaymentNotifications
      pushRequestNotifications
      isClaimed
      isSeeded
      licenseNumber
      licenseValidTo
      dataSource
      claimedAt
      isBlacklisted
      latitude
      longitude
      borough
      ownerSub
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const claimCompany =  `
  mutation ClaimCompany(
    $companyId: ID!
    $licenseNumber: String
    $ownerSub: String
    $action: String!
    $companyUser: String
    $email: AWSEmail
    $disputantName: String
    $disputantEmail: String
    $disputantPhone: String
    $disputantLicense: String
    $disputeReason: String
  ) {
    claimCompany(
      companyId: $companyId
      licenseNumber: $licenseNumber
      ownerSub: $ownerSub
      action: $action
      companyUser: $companyUser
      email: $email
      disputantName: $disputantName
      disputantEmail: $disputantEmail
      disputantPhone: $disputantPhone
      disputantLicense: $disputantLicense
      disputeReason: $disputeReason
    ) {
      success
      message
      companyId
    }
  }
`;
export const createUser =  `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      user
      name
      email
      phone
      profilepicturekey
      backgroundpicturekey
      Reviews {
        nextToken
        __typename
      }
      Invoices {
        nextToken
        __typename
      }
      PaymentMethod {
        nextToken
        __typename
      }
      blocked
      isDeleted
      deletedAt
      originalUsername
      Requests {
        nextToken
        __typename
      }
      messageNotifications
      paymentNotifications
      requestSatusNotifications
      invoiceNotifications
      pushMessageNotifications
      pushPaymentNotifications
      pushRequestSatusNotifications
      pushInvoiceNotifications
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser =  `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      user
      name
      email
      phone
      profilepicturekey
      backgroundpicturekey
      Reviews {
        nextToken
        __typename
      }
      Invoices {
        nextToken
        __typename
      }
      PaymentMethod {
        nextToken
        __typename
      }
      blocked
      isDeleted
      deletedAt
      originalUsername
      Requests {
        nextToken
        __typename
      }
      messageNotifications
      paymentNotifications
      requestSatusNotifications
      invoiceNotifications
      pushMessageNotifications
      pushPaymentNotifications
      pushRequestSatusNotifications
      pushInvoiceNotifications
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAnalyticsEvent =  `
  mutation CreateAnalyticsEvent(
    $input: CreateAnalyticsEventInput!
    $condition: ModelAnalyticsEventConditionInput
  ) {
    createAnalyticsEvent(input: $input, condition: $condition) {
      id
      eventType
      timestamp
      sessionId
      deviceId
      userId
      platform
      page
      referrer
      metadata
      duration
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser =  `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      user
      name
      email
      phone
      profilepicturekey
      backgroundpicturekey
      Reviews {
        nextToken
        __typename
      }
      Invoices {
        nextToken
        __typename
      }
      PaymentMethod {
        nextToken
        __typename
      }
      blocked
      isDeleted
      deletedAt
      originalUsername
      Requests {
        nextToken
        __typename
      }
      messageNotifications
      paymentNotifications
      requestSatusNotifications
      invoiceNotifications
      pushMessageNotifications
      pushPaymentNotifications
      pushRequestSatusNotifications
      pushInvoiceNotifications
      createdAt
      updatedAt
      __typename
    }
  }
`;
